// extracted by mini-css-extract-plugin
module.exports = {"Container":"OpenInRiveCommunityButton_Container__LSDS7","Icon":"OpenInRiveCommunityButton_Icon__Y4kN9"};